import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const BoxWrapper = styled(Box)(({ theme }) => ({
  '&.content': {
    backgroundColor: theme.palette.grey[50],
    padding: '8px',
    margin: '8px 0px',
    '& .title': {
      fontSize: '16px',
      color: theme.palette.text.primary,
      lineHeight: '18px',
      letterSpacing: '0.15px',
      fontWeight: '500',
      marginBottom: 12,
    },
  },
}))
